import * as React from 'react';
import Button from '@mui/material/Button';
// import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
// import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import Footer from '../../components/footer';
import Header from '../../components/header';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
//import LeftSection from '../../components/leftsection';
//import { Container } from '@mui/material';
//import { useToasts } from 'react-toast-notifications';
import LeftSection from '../../components/leftsection';
import { useSnackbar } from 'notistack';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import appTheme from '../../components/apptheme';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import validateResetPasswordForm from './ValidateChangePasswordForm';
import validateConfirmResetPasswordForm from './ValidateConfirmResetPasswordForm';
import * as loginActions from '../../actions/loginActions';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Constants from '../../config/constants';
import { InputAdornment, IconButton } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { VisibilityOff } from '@mui/icons-material';

export default function ResetPassword() {
  const st = useSelector((state) => state.rootReducer);
  const [activeStep, setActiveStep] = React.useState(0);
  let navigate = useNavigate();
  //const { addToast } = useToasts();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const [confirmEmail, setConfirmEmail] = useState();
  const [form1SubmitState, setForm1SubmitState] = useState(false);
  const [form2SubmitState, setForm2SubmitState] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const handleClickShowPassword1 = () => setShowPassword1(!showPassword1);
  const handleMouseDownPassword1 = () => setShowPassword1(!showPassword1);
  const [showPassword2, setShowPassword2] = useState(false);
  const handleClickShowPassword2 = () => setShowPassword2(!showPassword2);
  const handleMouseDownPassword2 = () => setShowPassword2(!showPassword2);

  // step 1
  React.useEffect(() => {
    if (form1SubmitState && !st.isUpdateAccountPasswordLoading && st.resetpwderror === '') {
      console.log('Navigate to Confirm Reset Password page');
      setActiveStep(1);
      setForm1SubmitState(false);
    }
  }, [st.isUpdateAccountPasswordLoading, form1SubmitState, st.resetpwderror]);

  const submitResetPassword = (values) => {
    console.log(values);
    setConfirmEmail(values.email);
    dispatch(loginActions.requestResetPassword(values.email));
    setForm1SubmitState(true);
  };

  const formik = useFormik({
    initialValues: {
      email: st.email
    },
    validationSchema: validateResetPasswordForm,
    onSubmit: (values) => {
      // alert('Submit ResetPassword API\n' + JSON.stringify(values, null, 2));
      submitResetPassword(values);
    }
  });

  // step 2
  React.useEffect(() => {
    if (form2SubmitState && !st.isUpdateAccountPasswordLoading && st.resetpwdconfirmerror === '') {
      console.log('Navigate to sign in page');
      dispatch(loginActions.clearError());
      enqueueSnackbar(Constants.RESET_PASSWORD_SUCCESS, {
        variant: 'success'
      });
      navigate('/sop2web/signin');
      setForm2SubmitState(false);
    }
  }, [st.isUpdateAccountPasswordLoading, form2SubmitState, st.resetpwdconfirmerror]);

  const submitResetPasswordConfirm = (values) => {
    dispatch(
      loginActions.requestResetPasswordConfirm(confirmEmail, values.code, values.newPassword)
    );
    setForm2SubmitState(true);
  };

  return (
    <ThemeProvider theme={appTheme}>
      <Header />
      <Box>
        <Grid container component="main" sx={styles.containerStyle}>
          {/* <CssBaseline /> */}
          <Grid item xs={12} sm={12} md={6} sx={styles.photoSectionStyle}>
            <LeftSection />
          </Grid>
          <Grid item xs={12} sm={12} md={6} sx={styles.rightSectionGridStyle}>
            {/* <CheckCircleIcon color="success" sx={{ fontSize: 100, mt: 4, mb: 2 }} /> */}
            {activeStep === 0 ? (
              <Box sx={styles.titleBoxStyle}>
                <Box sx={styles.confirmCardContainerStyle}>
                  <Box
                    component="img"
                    alt="Heart Opinion"
                    src={require('../../images/Lock.png')}
                    sx={{ mt: 4, mb: 2 }}
                  />
                  <Typography variant="h6">Reset your password</Typography>
                  <Typography variant="body2" sx={{ width: '320px', textAlign: 'center', mt: 1 }}>
                    We&apos;ll send a confirmation code to your email address.
                  </Typography>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={formik.handleSubmit}
                    sx={styles.formCardInputStyle}>
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoFocus
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      error={formik.touched.email && Boolean(formik.errors.email)}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                    <Box>
                      <Typography style={styles.errorText}>{st.resetpwderror}</Typography>
                    </Box>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        submitResetPassword(formik.values);
                      }}
                      sx={{ mt: 4, mb: 1 }}>
                      Send Verification Code
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 4,
                      mb: 6
                    }}>
                    <RouterLink
                      to="/sop2web/signin"
                      onClick={() => {
                        if (st.resetpwderror !== '') dispatch(loginActions.clearError());
                        console.info('Navigate to Sign in page.');
                      }}
                      sx={styles.linkTextStyle}
                      variant="body1"
                      color="inherit">
                      Back to Sign In
                    </RouterLink>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box sx={styles.confirmCardContainerStyle}>
                <CheckCircleIcon color="success" sx={{ fontSize: 100, mt: 4, mb: 2 }} />
                <Typography variant="h6">Confirmation Code Sent!</Typography>
                <Typography variant="body2" sx={{ width: '320px', textAlign: 'center', mt: 1 }}>
                  Check your email address for your confirmation code.
                </Typography>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    code: '',
                    newPassword: '',
                    newPassword2: '',
                    error: ''
                  }}
                  validationSchema={validateConfirmResetPasswordForm}
                  onSubmit={(values) => {
                    submitResetPasswordConfirm(values);
                  }}>
                  {(propsForm) => (
                    <Box
                      component="form"
                      noValidate
                      onSubmit={propsForm.handleSubmit}
                      sx={styles.formCardInputStyle}>
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="Comfirmation Code"
                        name="code"
                        // type="number"
                        // autoComplete="chrome-off"
                        // helperText="Confirmation code has been sent to your email. Please check your email for your confirmation code."
                        autoFocus
                        value={propsForm.values.code}
                        onChange={propsForm.handleChange}
                        error={propsForm.touched.code && Boolean(propsForm.errors.code)}
                        helperText={propsForm.touched.code && propsForm.errors.code}
                      />
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="newPassword"
                        label="New Password"
                        type={showPassword1 ? 'text' : 'password'}
                        autoComplete="false"
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword1}
                                onMouseDown={handleMouseDownPassword1}>
                                {showPassword1 ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        value={propsForm.values.newPassword}
                        onChange={propsForm.handleChange}
                        error={
                          propsForm.touched.newPassword && Boolean(propsForm.errors.newPassword)
                        }
                        helperText={propsForm.touched.newPassword && propsForm.errors.newPassword}
                      />
                      <TextField
                        margin="normal"
                        required
                        fullWidth
                        label="Repeat New Password"
                        type={showPassword2 ? 'text' : 'password'}
                        id="newPassword2"
                        autoComplete="off"
                        InputProps={{
                          // <-- This is where the toggle button is added.
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword2}>
                                {showPassword2 ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          )
                        }}
                        onChange={propsForm.handleChange}
                        error={
                          propsForm.touched.newPassword2 && Boolean(propsForm.errors.newPassword2)
                        }
                        helperText={propsForm.touched.newPassword2 && propsForm.errors.newPassword2}
                      />
                      <Box>
                        <Typography style={styles.errorText}>{st.resetpwdconfirmerror}</Typography>
                      </Box>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        onClick={propsForm.handleSubmit}
                        color="primary"
                        sx={{ mt: 4, mb: 1 }}>
                        Change Password
                      </Button>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mt: 4,
                          mb: 6
                        }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                          <RouterLink
                            to="/sop2web/signin"
                            onClick={() => {
                              if (st.resetpwderror !== '') dispatch(loginActions.clearError());
                              console.info('Navigate to Sign in page.');
                            }}
                            sx={{ color: '#003087' }}
                            variant="body1"
                            color="inherit">
                            Back to Sign In
                          </RouterLink>
                        </Box>
                      </Box>
                    </Box>
                  )}
                </Formik>
              </Box>
            )}
          </Grid>
          <Footer />
        </Grid>
      </Box>
    </ThemeProvider>
  );
}
const styles = {
  containerStyle: {
    // height: '86vh',
    display: 'flex',
    // alignItems: 'center',
    border: 0,
    justifyContent: 'center',
    backgroundColor: '#EDF3FC'
  },
  photoSectionStyle: {
    backgroundColor: '#EDF3FC',
    display: 'flex',
    alignItems: 'center',
    border: 0
    // justifyContent: 'center'
  },
  rightSectionGridStyle: {
    // height: '100%',
    backgroundColor: '#EDF3FC',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: 0,
    minWidth: 500
  },
  titleBoxStyle: {
    alignItems: 'flex-start',
    py: 4
  },
  titleStackStyle: {
    alignItems: 'flex-start'
  },
  formCardContainerStyle: {
    my: 2,
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 500,
    background: '#FFFF'
  },
  formCardTitleStyle: {
    mt: 2,
    mx: 2,
    alignItems: 'center',
    justifyContent: 'center'
  },
  formCardInputStyle: {
    mt: 2,
    width: 380
  },
  formCardButtonStyle: {
    mt: 1,
    mb: 2,
    flex: 1
  },
  formCardOneNavigateStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    mb: 4
  },
  linkTextStyle: {
    color: '#003087'
  },
  downloadContainerStyle: {
    my: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  confirmCardContainerStyle: {
    display: 'flex',
    border: 0,
    boxShadow: 1,
    borderColor: '#747678',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 500,
    background: '#FFFF'
  },
  errorText: {
    color: '#d32f2f',
    // fontWeight: "normal",
    fontSize: 16,
    //marginBottom: 10,
    marginTop: 0,
    marginLeft: 10,
    textAlign: 'left'
  }
};
